import LockIcon from '@mui/icons-material/Lock';
import { StyledCard, StyledRoot, StyledTypography, TitleWrapper, Wrapper } from './Section.styles';

interface SectionProps {
  title: string;
  children: React.ReactNode;
  id?: string;
  headerAction?: React.ReactNode;
}

const Section = ({ title, children, id, headerAction }: SectionProps) => (
  <StyledRoot id={id}>
    <Wrapper>
      <TitleWrapper>
        <StyledTypography>{title}</StyledTypography>
        {headerAction}
      </TitleWrapper>
      <LockIcon fontSize="small" color="disabled" />
    </Wrapper>

    <StyledCard>{children}</StyledCard>
  </StyledRoot>
);

export default Section;
